import React from 'react';
import ExpHero from '../Experience/ExpHero/ExpHero';
import Footer from '../Home/Footer/Footer';
import Navbar from '../Home/Navbar/Navbar';
import CasePost from './CasePost/CasePost';
import './CaseStudy.css';

const CaseStudy = () => {
    return (
        <div>
            <Navbar/>
            <ExpHero text="CASE STUDY"></ExpHero>
            <CasePost/>
            <Footer/>
            
        </div>
    );
};

export default CaseStudy;